/**
 * HIBANA (application_id 132) のテーマカラー。
 * base = magenta-500(#CB11DF) / 600、accent = magenta-400 のグラデーション。
 */
import { tailwindScales as tw } from "../tailwindColors";
import type { ThemePalette } from "../types";

export const HIBANA_PALETTE: ThemePalette = {
  appId: "132",
  appName: "HIBANA",
  cyan: tw.magenta,
  teal: tw.magenta,
  gradient: { from: tw.magenta[500], to: tw.magenta[400] },
  ink: { base: "#2B0A2E", soft: "#7A3D74", mute: "#B58AB0" },
  app: { bg: "#FDF4FD", card: "#FFFFFF" },
};
